import { useShopStores } from './use-store'
import { expressCheckoutComponentMaps } from '../utils/express-checkout-map'

export const useExpressCheckout = () => {
  const { experimentsStore } = useShopStores()

  const expressCheckoutConfig = experimentsStore?.getDynamicConfig('express_checkout_config')
  const expressCheckoutMethods = (expressCheckoutConfig?.value.express_checkout as string[]) || []

  // Filter out methods that return null (not available) and render only available ones
  const availableExpressCheckoutComponents = expressCheckoutMethods
    .map((method) => {
      const component = expressCheckoutComponentMaps()[method]
      return component ? component() : null
    })
    .filter(Boolean)

  return {
    expressCheckoutMethods,
    availableExpressCheckoutComponents,
    hasAvailableExpressCheckout: availableExpressCheckoutComponents.length > 0,
  }
}
